"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Video = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Video = require("./Video.style");

var Video = function Video(_ref) {
  var url = _ref.url,
      playing = _ref.playing,
      loop = _ref.loop,
      controls = _ref.controls,
      muted = _ref.muted,
      thumbnail = _ref.thumbnail,
      children = _ref.children,
      aspectRatio = _ref.aspectRatio,
      zoom = _ref.zoom,
      height = _ref.height,
      className = _ref.className,
      stopOutOfViewport = _ref.stopOutOfViewport,
      rest = _objectWithoutProperties(_ref, ["url", "playing", "loop", "controls", "muted", "thumbnail", "children", "aspectRatio", "zoom", "height", "className", "stopOutOfViewport"]);

  var _ref2 = (0, _reactIntersectionObserver.useInView)({
    threshold: 0.4
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      ref = _ref3[0],
      inView = _ref3[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_Video.VideoBox, {
    aspectRatio: aspectRatio,
    height: height,
    ref: ref
  }, url && /*#__PURE__*/_react.default.createElement(_Video.VideoPlayer, Object.assign({
    zoom: zoom,
    url: url,
    playing: stopOutOfViewport && !inView ? false : playing,
    loop: loop,
    controls: controls,
    muted: muted,
    light: thumbnail,
    width: "100%",
    height: "100%",
    className: "player"
  }, rest)), children && /*#__PURE__*/_react.default.createElement(_Video.VideoOverlay, null, children)));
};

exports.Video = Video;
var _default = Video;
exports.default = _default;
Video.propTypes = {
  /**  URL can be MP4 or one of Facebook, Vimeo, Youtube (check docs for full list) */
  url: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string]).isRequired,

  /**  Aspect Ratio of video to format X:Y (e.g. 21:9) */
  aspectRatio: _propTypes.default.string,
  zoom: _propTypes.default.string,
  height: _propTypes.default.string,
  className: _propTypes.default.string,
  playing: _propTypes.default.bool,

  /** Control if video stops autoplay outside of viewport */
  stopOutOfViewport: _propTypes.default.bool,
  loop: _propTypes.default.bool,
  controls: _propTypes.default.bool,
  muted: _propTypes.default.bool,
  playsinline: _propTypes.default.bool,

  /** String should be the url of the thumbnail */
  thumbnail: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  children: _propTypes.default.node
};
Video.defaultProps = {
  aspectRatio: '4:3',
  zoom: '1',
  height: '0',
  playing: false,
  className: '',
  loop: false,
  controls: true,
  muted: false,
  stopOutOfViewport: true,
  playsinline: false,
  thumbnail: false,
  children: null
};